export default __webpack_public_path__ + "static/media/TINTOC2024.ccbcc4b0cfb5e46744f239aeee215e71.png";